import React from "react";

interface HamburgerProps {
  isOpen?: boolean;
  className?: string;
  onClick?: () => void;
}

const Hamburger: React.FC<HamburgerProps> = ({
  isOpen = false,
  className = "",
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-11 h-11 flex flex-col items-center justify-center gap-1.5 rounded transition-all duration-300 bg-[#133345] hover:bg-[#1a4055] active:scale-95 ${className}`}
      aria-label={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
      style={{ minWidth: "44px", minHeight: "44px" }}
    >
      <span
        className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 ${
          isOpen ? "rotate-45 translate-y-2" : ""
        }`}
      />
      <span
        className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 ${
          isOpen ? "opacity-0" : "opacity-100"
        }`}
      />
      <span
        className={`block w-5 h-0.5 bg-white rounded-full transition-all duration-300 ${
          isOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      />
    </button>
  );
};

export default Hamburger;
